import { createRuntime } from './runtime.js';
import { initializeAdmin } from './admin.js';

const AsteroUI = createRuntime(initializeAdmin);
export default AsteroUI;
